/* =========================================================
   DOPAMEAN — Close the filter drawer on backdrop click.
   Dawn's <form class="mobile-facets"> is the full-viewport
   overlay; <.mobile-facets__inner> is the right-side panel.
   A click on the form but OUTSIDE the inner panel should
   close the drawer. We trigger the existing summary click
   so all of Dawn's bookkeeping (focus trap, body scroll
   lock, ARIA state) unwinds correctly.
   ========================================================= */
(function () {
  function closeDrawer(details) {
    if (!details || !details.hasAttribute('open')) return;
    const summary = details.querySelector('summary');
    if (summary) summary.click();
  }

  function bindForm(form) {
    if (form.dataset.dpmCloseBound === '1') return;
    form.dataset.dpmCloseBound = '1';

    form.addEventListener('click', function (event) {
      // Ignore clicks on the inner panel or any of its descendants.
      const innerPanel = form.querySelector('.mobile-facets__inner');
      if (innerPanel && innerPanel.contains(event.target)) return;
      // The click landed on the form's scrim — close the drawer.
      const details = form.closest('details.mobile-facets__disclosure');
      closeDrawer(details);
    });
  }

  function init() {
    document.querySelectorAll('form.mobile-facets').forEach(bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind after Dawn re-renders the facets form on filter / sort change.
  document.addEventListener('shopify:section:load', init);
  const observerTarget = document.querySelector('#main-collection-product-grid, #ProductGridContainer');
  if (observerTarget && typeof MutationObserver !== 'undefined') {
    new MutationObserver(init).observe(observerTarget, { childList: true, subtree: true });
  }
})();
